import { ConfigurationApi, Configuration as ConfigurationApiOptions, } from "@plansoft-configuration-renderer/configuration-api";
/**
 * Helper for creating a {@link ConfigurationApi}
 * @category Helper
 *
 * [Explanation for cors issues](https://javascript.info/fetch-crossorigin)
 */
export function createConfigurationApi(options) {
    const { basePath, apiKey } = options;
    const parameters = {};
    if (basePath) {
        parameters.basePath = basePath;
    }
    // apiKey property on params does not work
    if (apiKey && typeof apiKey === "string") {
        if (/^basic|bearer/i.test(apiKey)) {
            parameters.headers = { authorization: apiKey };
        }
    }
    return new ConfigurationApi(new ConfigurationApiOptions(parameters));
}
//# sourceMappingURL=createConfigurationApi.js.map